import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    width: 340,
    flex: 1,
    justifyContent: "space-between",
    padding: 16,
    alignSelf: "center",

    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  receiver: {
    marginBottom: 4,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 8,
  },
  textBold: {
    fontWeight: "bold",
  },

  summary: {
    marginTop: 16,
    marginBottom: 32,
  },
  spaceBetween: {
    marginTop: 12,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  btnConfimeSaque: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    marginHorizontal: "auto",
    color: "#fff",
  },

  confirmacaoSaque: {
    color: "#077A97",
    textAlign: "center",
  },

  hrLine: {
    height: 0.2,
    width: "100%",
    borderWidth: 0.2,
    /* marginTop: 10, */
    marginBottom: 10,
    borderColor: "#077A97",
  },

  label: {
    textTransform: "uppercase",
  },
});
